<template>
  <div class="SummaryPage">
    <MainPageHeader v-if="!isAndroidContext"/>
    <div v-if="getProductId === '3' || getProductId === '4'"
         :class="{'android-content': isAndroidContext}"
         class="content">
      <header v-if="!isAndroidContext" class="main-header">
        <p class="font-size-middle">Krok 1 z 3</p>
      </header>
      <div v-if="!isAndroidContext" class="divider"/>
      <div v-if="!isAndroidContext" class="text-header">
        <h1 class="font-size-big">Zaakceptuj niezbędne zgody</h1>
      </div>
      <section class="section section-1">
        <div class="info">
          <PolicyRow :checked="areAllCheckboxChecked" :isObligatory="false" @input="acceptAllInput">
            <a class="accept-all font-size-small"> Akceptuję wszystkie poniższe zgody Vocale Sp. z o.o.</a>
          </PolicyRow>
          <PolicyRow :checked="policyStates[0]" :isObligatory="true" class="inset" @input="policyInput(0, $event)">
            Proszę o natychmiastowe rozpoczęcie świadczenia treści cyfrowych (przed upływem 14-dniowego terminu na
            odstąpienie od umowy). Tym samym przyjmuję do wiadomości, że od tego momentu nie mogę odstąpić od umowy.
          </PolicyRow>
          <PolicyRow :checked="policyStates[1]" :isObligatory="true" class="inset" @input="policyInput(1, $event)">
            Przyjmuję do wiadomości, że w związku z zawarciem umowy na czas nieoznaczony, moja karta płatnicza będzie
            cyklicznie oraz automatycznie obciążana kwotą należności za dostęp do treści cyfrowych w poszczególnych
            okresach rozliczeniowych. Obciążenia będą dokonywane za czas dostępu trwający do końca okresu
            rozliczeniowego, w którym zrezygnuję z subskrypcji. W przypadku rezygnacji z subskrypcji po zawarciu umowy,
            a przed aktywacją subskrypcji, obciążenie będzie dotyczyć pierwszego okresu rozliczeniowego.
          </PolicyRow>
          <PolicyRow :checked="policyStates[2]" :isObligatory="true" class="inset" @input="policyInput(2, $event)">
            Akceptuję <a class="yellow-link">Warunki korzystania z usługi</a> oraz
            <a class="yellow-link">Politykę prywatności</a>.
          </PolicyRow>
          <p class="red-info font-size-small">* Pola obowiązkowe do wypełnienia</p>
        </div>
      </section>
    </div>
    <div v-if="getProductId === '2'" class="content">
      <header class="main-header">
        <p class="font-size-middle">Krok 1 z 3</p>
      </header>
      <div class="divider"/>
      <div class="text-header">
        <h1 class="font-size-big">Zaakceptuj niezbędne zgody</h1>
      </div>
      <section class="section section-1">
        <div class="info">
          <PolicyRow :checked="areAllCheckboxChecked" :isObligatory="false" @input="acceptAllInput">
            <a class="accept-all"> Akceptuję wszystkie poniższe zgody Vocale Sp. z o.o.</a>
          </PolicyRow>
          <PolicyRow :checked="policyStates[0]" :isObligatory="true" class="inset" @input="policyInput(0, $event)">
            Proszę o natychmiastowe rozpoczęcie świadczenia treści cyfrowych (przed upływem 14-dniowego terminu na
            odstąpienie od umowy). Tym samym przyjmuję do wiadomości, że od tego momentu nie mogę odstąpić od umowy.
          </PolicyRow>
          <PolicyRow :checked="policyStates[1]" :isObligatory="true" class="inset" @input="policyInput(1, $event)">
            Przyjmuję do wiadomości oraz akceptuję, iż w związku z dużą ilością zamowień, realizacja dostarczania
            sprzętu może się przedłużyć do 14 dni roboczych.
          </PolicyRow>
          <PolicyRow :checked="policyStates[2]" :isObligatory="true" class="inset" @input="policyInput(2, $event)">
            Akceptuję <a class="yellow-link">Warunki korzystania z usługi</a> oraz
            <a class="yellow-link">Politykę prywatności</a>.
          </PolicyRow>
          <p class="red-info font-size-small">* Pola obowiązkowe do wypełnienia</p>
        </div>
      </section>
    </div>
    <TabFooter :buttonEnabled="areAllCheckboxChecked"
               :name="getProductDetails.name"
               :period="getProductDetails.period"
               :price="productDetails.price"
               :quantity="productDetails.quantity" @buttonClicked="proceedToAddressPage"/>
    <PageNotFound v-if="loadError" :message="loadError"/>
    <ContentLoader v-if="!productDetails"/>
  </div>
</template>

<script>
import MainPageHeader from '../components/MainPageHeader.vue'
import PageNotFound from '../components/PageNotFound.vue'
import ContentLoader from '../components/ContentLoader.vue'
import TabFooter from '../components/TabFooter.vue'
import PolicyRow from '../components/PolicyRow.vue'
import { getAuthService } from '../services/authService'
import { productDatabase } from '@/services/mock/productDatabase'
import { getAndroidContext } from '@/services/sessionProps'
import {getProductService} from "@/services/productService";

export default {
  name: 'SummaryPage',
  components: {
    MainPageHeader,
    PageNotFound,
    ContentLoader,
    TabFooter,
    PolicyRow,
  },

  data () {
    return {
      productDetails: {
        key: '',
        name: '',
        price: '',
        period: '',
        quantity: ''
      },
      loadError: null,
      policyStates: [false, false, false],
      loggedInEmail: null,
      isAndroidContext: false,
    }
  },

  mounted () {
    window.scrollTo(0,0);
    (async () => {
      this.productDetails = await getProductService().getProduct(this.$route.params.productId)
      
      if(this.productDetails.subscriptionProlongationDays === 0) {
        this.productDetails.price = (this.productDetails.price / 30)
      }
      this.productDetails.price = (this.productDetails.price / 100) + 'zł'

      this.isAndroidContext = getAndroidContext().isAndroidContext()

      if(document.querySelector('#chat-application') && this.isAndroidContext) {
        document.querySelector('#chat-application').classList.add('hidden-chat')
      }
      const [
        loggedInEmail,
      ] = await Promise.all([
        getAuthService().getLoggedInEmail(),
      ])

      this.loggedInEmail = loggedInEmail
      if (this.loggedInEmail == null) {
        this.$router.replace({
          name: 'logInPage',
          params: {id: this.$route.params.id, fromPage: `products/${this.$route.params.id}/summary`}
        })
      }
    })()
  },

  methods: {
    acceptAllInput () {
      if (this.policyStates.some(p => p == false)) {
        this.policyStates = this.policyStates.map(p => true)
      } else {
        this.policyStates = this.policyStates.map(p => false)
      }
    },

    policyInput (index, state) {
      const states = this.policyStates.slice()
      states[index] = !this.policyStates[index]
      this.policyStates = states
    },

    proceedToAddressPage () {
      if (!this.areAllCheckboxChecked) {
        return
      }

      if (this.loggedInEmail != null) {
        this.$router.push({ name: 'address', params: {
          product: this.productDetails,
          productId: this.getProductId
        } })
      } else {
        this.$router.push({ name: 'logInPage', params: { id: this.$route.params.id } })
      }
    },
  },

  computed: {
    getProductId() {
      return this.$route.params.productId
    },

    getProductDetails() {
      return productDatabase[this.getProductId]
    },

    areAllCheckboxChecked () {
      return !this.policyStates.some(p => p == false)
    },
  },

  beforeDestroy() {
    document.querySelector('#chat-application').classList.remove('hidden-chat')
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.TabPage {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto;
  grid-template-areas: 'header'
            'content'
            'footer';
  min-height: 100vh;
}

.MainPageHeader {
  grid-area: header;
}

.Footer {
  grid-area: footer;
}

.content {
  grid-area: content;

  padding: 0 20px;
  margin-top: 140px;
  margin-bottom: 100px;

  // Mobile style
  @media (max-width: $phone-max-width) {

    margin-top: 100px;

  }

  header.main-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 auto;
    max-width: 1300px;

    p {
      font-weight: bold;
    }

    h1 {
      margin-left: 20px;
      color: $primary;
    }
  }

  .text-header {
    padding: 20px 0;
    text-align: center;
    color: white;

    h1 {
      color: $primary;
    }

    h2 {
      color: $primary;
      font-weight: normal;
    }

    // Mobile style
    @media (max-width: $phone-max-width) {

      padding: 10px 0;
      margin-bottom: 20px;

      h1 {
        margin: 0;
      }
    }
  }

  .section {
    display: block;
    margin: 0 auto;
    margin-bottom: 30px;
    padding: 20px 30px;
    max-width: 1000px;
    border: 1px solid #aaa;

    header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      p {
        margin: 0;
        color: #ddd;
      }

      .image-placeholder {
        width: 40px;
        height: 30px;
        background-color: white;
      }
    }

    .info {
      flex: 1 1;

      .red-info {
        color: red;
      }

      .accept-all {
        font-weight: bold;
      }

      .inset {
        margin-left: 60px;
      }

      .yellow-link {
        color: $primary;
        text-decoration: underline;
        cursor: pointer;
      }

      // Mobile style
      @media (max-width: $phone-max-width) {
        .inset {
          margin-left: 20px;
        }
      }
    }

    .big-button {
      display: block;
      margin: 20px auto;
      margin-top: 60px;
      min-width: 400px;

      // Mobile style
      @media (max-width: $phone-max-width) {
        width: 100%;
        min-width: unset;
      }
    }
  }

  .section-1 {
    border-color: $primary;

    // Mobile style
    @media (max-width: $phone-max-width) {
      padding: 0;
      border: none;
    }
  }

  .divider {
    border-bottom: 1px solid #aaa;
  }
}

.android-content {
  margin-top: 30px;
}
</style>
